import React from "react";
import { Input, Space } from "antd";
import { CountrySelect } from "@ifa/ui";

export interface AddressInputValue {
  /**
   * 国家/地区代码
   */
  country?: string;
  /**
   * 详细地址
   */
  address?: string;
}

interface AddressInputProps {
  /**
   * 地址信息值
   */
  value?: AddressInputValue;
  /**
   * 地址信息变化回调
   */
  onChange?: (value: AddressInputValue) => void;
  /**
   * 是否只读
   */
  readOnly?: boolean;
  /**
   * 地址输入框占位符
   */
  placeholder?: string;
  /**
   * 国家选择框占位符
   */
  countryPlaceholder?: string;
}

/**
 * 通讯地址输入组件
 * 专用于输入国家/地区 + 详细地址
 */
export const AddressInput: React.FC<AddressInputProps> = ({
  value = {},
  onChange,
  readOnly = false,
  placeholder = "請輸入詳細通訊地址",
  countryPlaceholder = "請選擇",
}) => {
  const handleCountryChange = (country?: string) => {
    onChange?.({ ...value, country });
  };

  const handleAddressChange = (address: string) => {
    onChange?.({ ...value, address });
  };

  return (
    <Space.Compact style={{ width: "100%" }}>
      <CountrySelect
        type="country"
        style={{
          width: 140,
          borderRadius: "6px 0 0 6px",
        }}
        placeholder={countryPlaceholder}
        value={value.country}
        onChange={(_, c) => handleCountryChange(c?.countryCode)}
        readOnly={readOnly}
      />
      <Input
        placeholder={placeholder}
        value={value.address}
        style={{
          borderRadius: "0 6px 6px 0",
          borderLeft: "none",
        }}
        onChange={(e) => handleAddressChange(e.target.value)}
        disabled={readOnly}
      />
    </Space.Compact>
  );
};
